<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <div class="container mt-5">
      <div class="update-password card p-4 mx-auto">
        <h2 class="card-title text-center mb-4">Actualizar Contraseña</h2>
        <form @submit.prevent="handleSubmit" aria-live="polite">
          <!-- Campo oculto para el nombre de usuario -->
          <input
            type="text"
            :value="usuario"
            autocomplete="username"
            style="display: none;"
          />
          <div class="mb-3">
            <label for="currentPassword" class="form-label">Contraseña Actual</label>
            <input
              type="password"
              id="currentPassword"
              class="form-control"
              v-model.trim="currentPassword"
              autocomplete="current-password"
              required
              aria-describedby="currentPasswordError"
            />
          </div>
          <div class="mb-3">
            <label for="newPassword" class="form-label">Nueva Contraseña</label>
            <input
              type="password"
              id="newPassword"
              class="form-control"
              v-model.trim="newPassword"
              autocomplete="new-password"
              required
              aria-describedby="newPasswordError"
            />
          </div>
          <div class="mb-3">
            <label for="confirmPassword" class="form-label">Confirmar Nueva Contraseña</label>
            <input
              type="password"
              id="confirmPassword"
              class="form-control"
              v-model.trim="confirmPassword"
              autocomplete="new-password"
              required
              aria-describedby="confirmPasswordError"
            />
          </div>
          <button
            type="submit"
            class="btn btn-primary w-100"
            :disabled="isLoading"
          >
            <span v-if="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            {{ isLoading ? 'Actualizando...' : 'Actualizar Contraseña' }}
          </button>
          <div v-if="message" class="alert mt-3" :class="messageType" role="alert">
            {{ message }}
          </div>
        </form>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";

export default {
  name: "ActualizarClave",
  components: { Layout, Footer },
  props: {
    usuario: {
      type: String,
      default: "",	  
    },
    idUsuario: {
      type: Number,
      default: 0,	  
    },
  },
  data() {
    return {
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
      message: "",
      messageType: "", // 'alert-success' o 'alert-danger' para estilos
      isLoading: false,
    };
  },
  mounted() {
    // Configurar el componente Layout
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
  },
  methods: {
    // Validar los campos del formulario
    validateForm() {
      if (!this.currentPassword) {
        return { valid: false, message: "Ingrese la contraseña actual" };
      }
      if (!this.newPassword) {
        return { valid: false, message: "Ingrese la nueva contraseña" };
      }
      if (!this.confirmPassword) {
        return { valid: false, message: "Ingrese la confirmación de la contraseña" };
      }
      if (this.newPassword !== this.confirmPassword) {
        return { valid: false, message: "Las contraseñas no coinciden" };
      }
      if (this.newPassword.length < 8) {
        return { valid: false, message: "La nueva contraseña debe tener al menos 8 caracteres" };
      }
      return { valid: true };
    },
    // Manejar el envío del formulario
    async handleSubmit() {
      const validation = this.validateForm();
      if (!validation.valid) {
        this.message = validation.message;
        this.messageType = "alert-danger";
        return;
      }
      this.isLoading = true;
      this.message = "";
      const data = {
        claveActual: this.currentPassword,
        nuevaClave: this.newPassword,
      };

      try {
        const response = await api.post(`/actualizar-clave/${this.idUsuario}`, data);
        this.message = response.data || "Contraseña actualizada con éxito";
        this.messageType = "alert-success";
        // Limpiar todos los campos
        this.currentPassword = "";
        this.newPassword = "";
        this.confirmPassword = "";
      } catch (error) {
        this.message = error.response?.data || "Error al actualizar la contraseña";
        this.messageType = "alert-danger";
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.update-password {
  max-width: 500px;
  background-color: #fff;
}

.form-label {
  font-weight: 600;
}

.form-control {
  padding: 0.75rem;
  margin-bottom: 1rem;
}

.btn-primary {
  padding: 0.75rem;
  transition: background-color 0.2s ease-in-out;
}

.alert {
  margin-top: 1rem;
  padding: 0.75rem;
  border-radius: 0.25rem;
}

.alert-success {
  background-color: #d4edda;
  color: #155724;
}

.alert-danger {
  background-color: #f8d7da;
  color: #721c24;
}

@media (max-width: 576px) {
  .update-password {
    padding: 1rem;
  }

  .form-control {
    font-size: 0.9rem;
  }

  .btn-primary {
    font-size: 0.9rem;
  }
}
</style>